import axios from "axios";
import config from "./config";

const axiosInstanceV2 = axios.create({
  baseURL: config.BACKEND_CORE_V2_URL,
  // Send/receive the auth cookie on same-site credentialed requests.
  withCredentials: true,
});

export default axiosInstanceV2;
